'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { usePopover, usePreventScroll, Overlay } from '@react-aria/overlays';
import { tokensRaw } from '../../../core/tokens/tokens-raw.js';
import { useSwanPopover } from './popover.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useInternalDialogConfigContext as g } from '../modal-dialog/dialog.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { ROOT_CLASSNAMES } from '../../../core/constants/globals.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
let b = parseInt(tokensRaw.SwanSemSpace2) || 4;
const PopoverContentInternal = renderWithRef('PopoverContent', {}, (a, i)=>{
    let { children: u, offset: f = b, isNonModal: _ = false, portalContainer: m, hideArrow: j = false, fullBleed: y, className: O, placement: w = 'top', disableContainerPadding: v } = a, g$1 = _object_without_properties(a, [
        "children",
        "offset",
        "isNonModal",
        "portalContainer",
        "hideArrow",
        "fullBleed",
        "className",
        "placement",
        "disableContainerPadding"
    ]), { popoverRef: h, triggerRef: P, overlayProps: S, overlayState: k, modes: x, maxHeight: C } = useSwanPopover(), { inModal: D, portalRef: M, dialogRef: N } = g(), E = null != m ? m : D && M.current ? M.current : void 0, { popoverProps: I, underlayProps: B, placement: K, arrowProps: L } = usePopover({
        popoverRef: h,
        triggerRef: P,
        placement: w,
        offset: f,
        isNonModal: _,
        boundaryElement: D && N.current || void 0,
        containerPadding: v ? 0 : void 0,
        maxHeight: C
    }, k), A = assignRefs(i, h), R = new Set([
        ROOT_CLASSNAMES.base,
        'swan-popover'
    ]);
    return y && R.add('swan-popover-skin-full-bleed'), x.hasDarkMode && R.add(ROOT_CLASSNAMES.darkMode), x.hasCompactMode && R.add(ROOT_CLASSNAMES.compactMode), O && R.add(O), usePreventScroll({
        isDisabled: false
    }), jsxs(Overlay, _object_spread_props(_object_spread({}, S), {
        portalContainer: E,
        children: [
            !_ && jsx("div", _object_spread_props(_object_spread({}, B), {
                className: "swan-popover-underlay"
            })),
            jsxs(RenderComp, {
                root: "div",
                forwardedRef: A,
                props: _object_spread_props(_object_spread({}, g$1, I), {
                    'data-placement': j ? void 0 : K
                }),
                classNames: R,
                children: [
                    j ? null : jsx("svg", _object_spread_props(_object_spread({}, L), {
                        className: "swan-popover-arrow",
                        viewBox: "0 0 24 24",
                        children: jsx("path", {
                            d: "M0 0 L12 12 L24 0"
                        })
                    })),
                    u
                ]
            })
        ]
    }));
});

export { PopoverContentInternal };
